import { stateGo, stateReload } from 'redux-ui-router';

angular.module('tct.actions', [])
  .factory('actionsFactory', actionsFactory);

actionsFactory.$inject = ['$ngRedux'];

// auth actions
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const AUTH_GRANTED = 'AUTH_GRANTED';
export const SKIP_LOGIN = 'SKIP_LOGIN';
export const AUTH_ERROR = 'AUTH_ERROR';
export const FETCH_AUTH = 'FETCH_AUTH';
export const REQUEST_LOGIN_RESET = 'REQUEST_LOGIN_RESET';
export const REQUEST_ME = 'REQUEST_ME';
export const REQUEST_ME_SUCCESS = 'REQUEST_ME_SUCCESS';
export const REQUEST_ME_ERROR = 'REQUEST_ME_ERROR';
export const REQUEST_USERLIST_START = 'REQUEST_USERLIST_START';
export const REQUEST_CLIENT_USERLIST_START = 'REQUEST_CLIENT_USERLIST_START';
export const REQUEST_NON_CLIENT_USERLIST_START = 'REQUEST_NON_CLIENT_USERLIST_START';
export const REQUEST_EDITOR_USERLIST_START = 'REQUEST_EDITOR_USERLIST_START';
export const REQUEST_USERLIST_SUCCESS = 'REQUEST_USERLIST_SUCCESS';
export const REQUEST_USERLIST_ERROR = 'REQUEST_USERLIST_ERROR';
export const ACTIVATION_START = 'ACTIVATION_START';
export const ACTIVATION_ERROR = 'ACTIVATION_ERROR';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const ACTIVATION_PASSWORD_START = 'ACTIVATION_PASSWORD_START';
export const ACTIVATION_FINISH = 'ACTIVATION_FINISH';
export const ACTIVATION_PASSWORD_ERROR = 'ACTIVATION_PASSWORD_ERROR';
export const REFUSE_USER = 'REFUSE_USER';
export const REFUSE_USER_SUCCESS = 'REFUSE_USER_SUCCESS';
export const REFUSE_USER_ERROR = 'REFUSE_USER_ERROR';
export const ACCEPT_USER = 'ACCEPT_USER';
export const ACCEPT_USER_SUCCESS = 'ACCEPT_USER_SUCCESS';
export const ACCEPT_USER_ERROR = 'ACCEPT_USER_ERROR';
export const REVIEWING_ASK = 'REVIEWING_ASK';
export const REVIEWING_ASK_SUCCESS = 'REVIEWING_ASK_SUCCESS';
export const REVIEWING_ASK_ERROR = 'REVIEWING_ASK_ERROR';
export const ADD_USER = 'ADD_USER';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_ERROR = 'ADD_USER_ERROR';
export const REQUEST_COMPANY_START = 'REQUEST_COMPANY_START';
export const REQUEST_COMPANY_SUCCESS = 'REQUEST_COMPANY_SUCCESS';
export const REQUEST_COMPANY_ERROR = 'REQUEST_COMPANY_ERROR';
export const REQUEST_COMPANYLIST_START = 'REQUEST_COMPANYLIST_START';
export const REQUEST_COMPANYLIST_SUCCESS = 'REQUEST_COMPANYLIST_SUCCESS';
export const REQUEST_COMPANYLIST_ERROR = 'REQUEST_COMPANYLIST_ERROR';
export const REQUEST_BUSINESSINFO_START = 'REQUEST_BUSINESSINFO_START';
export const REQUEST_BUSINESSINFO_SUCCESS = 'REQUEST_BUSINESSINFO_SUCCESS';
export const REQUEST_BUSINESSINFO_ERROR = 'REQUEST_BUSINESSINFO_ERROR';
export const REQUEST_BUSINESSINFO_ORDER_START = 'REQUEST_BUSINESSINFO_ORDER_START';
export const REQUEST_BUSINESSINFO_ORDER_SUCCESS = 'REQUEST_BUSINESSINFO_ORDER_SUCCESS';
export const REQUEST_BUSINESSINFO_ORDER_ERROR = 'REQUEST_BUSINESSINFO_ORDER_ERROR';
export const REQUEST_COMPANY_STRUCTURE_START = 'REQUEST_COMPANY_STRUCTURE_START';
export const REQUEST_COMPANY_STRUCTURE_SUCCESS = 'REQUEST_COMPANY_STRUCTURE_SUCCESS';
export const REQUEST_COMPANY_STRUCTURE_ERROR = 'REQUEST_COMPANY_STRUCTURE_ERROR';
export const REQUEST_COMPANY_BUDGETS_START = 'REQUEST_COMPANY_BUDGETS_START';
export const REQUEST_COMPANY_BUDGETS_SUCCESS = 'REQUEST_COMPANY_BUDGETS_SUCCESS';
export const REQUEST_COMPANY_BUDGETS_ERROR = 'REQUEST_COMPANY_BUDGETS_ERROR';
export const REQUEST_COMPANY_CONTRACTS_START = 'REQUEST_COMPANY_CONTRACTS_START';
export const REQUEST_COMPANY_CONTRACTS_SUCCESS = 'REQUEST_COMPANY_CONTRACTS_SUCCESS';
export const REQUEST_COMPANY_CONTRACTS_ERROR = 'REQUEST_COMPANY_CONTRACTS_ERROR';
export const REQUEST_ENUM_START = 'REQUEST_ENUM_START';
export const REQUEST_ENUM_SUCCESS = 'REQUEST_ENUM_SUCCESS';
export const REQUEST_ENUM_ERROR = 'REQUEST_ENUM_ERROR';
export const REQUEST_TECHDOCLIST_START = 'REQUEST_TECHDOCLIST_START';
export const REQUEST_TECHDOCLIST_SUCCESS = 'REQUEST_TECHDOCLIST_SUCCESS';
export const REQUEST_TECHDOCLIST_ERROR = 'REQUEST_TECHDOCLIST_ERROR';
export const REQUEST_TECHDOC_START = 'REQUEST_TECHDOC_START';
export const REQUEST_TECHDOC_SUCCESS = 'REQUEST_TECHDOC_SUCCESS';
export const REQUEST_TECHDOC_ERROR = 'REQUEST_TECHDOC_ERROR';
export const REQUEST_QUESTIONNAIRELIST_START = 'REQUEST_QUESTIONNAIRELIST_START';
export const REQUEST_QUESTIONNAIRELIST_SUCCESS = 'REQUEST_QUESTIONNAIRELIST_SUCCESS';
export const REQUEST_QUESTIONNAIRELIST_ERROR = 'REQUEST_QUESTIONNAIRELIST_ERROR';
export const REQUEST_QUESTIONNAIRE_START = 'REQUEST_QUESTIONNAIRE_START';
export const REQUEST_QUESTIONNAIRE_SUCCESS = 'REQUEST_QUESTIONNAIRE_SUCCESS';
export const REQUEST_QUESTIONNAIRE_ERROR = 'REQUEST_QUESTIONNAIRE_ERROR';
export const UPDATE_QUESTIONNAIRE_START = 'UPDATE_QUESTIONNAIRE_START';
export const UPDATE_QUESTIONNAIRE_SUCCESS = 'UPDATE_QUESTIONNAIRE_SUCCESS';
export const UPDATE_QUESTIONNAIRE_ERROR = 'UPDATE_QUESTIONNAIRE_ERROR';
export const UPDATE_TECHDOC = 'UPDATE_TECHDOC';
export const UPDATE_TECHDOC_SUCCESS = 'UPDATE_TECHDOC_SUCCESS';
export const UPDATE_TECHDOC_ERROR = 'UPDATE_TECHDOC_ERROR';
export const SAVE_TECHDOC_START = 'SAVE_TECHDOC_START';
export const SAVE_TECHDOC_SUCCESS = 'SAVE_TECHDOC_SUCCESS';
export const SAVE_TECHDOC_ERROR = 'SAVE_TECHDOC_ERROR';
export const UPDATE_CONTRACT_START = 'UPDATE_CONTRACT_START';
export const UPDATE_CONTRACT_SUCCESS = 'UPDATE_CONTRACT_SUCCESS';
export const UPDATE_CONTRACT_ERROR = 'UPDATE_CONTRACT_ERROR';
export const CREATE_TECHDOC = 'CREATE_TECHDOC';
export const CREATE_TECHDOC_SUCCESS = 'CREATE_TECHDOC_SUCCESS';
export const CREATE_TECHDOC_ERROR = 'CREATE_TECHDOC_ERROR';
export const SET_TECHDOC_TO_DRAFT_START = 'SET_TECHDOC_TO_DRAFT_START';
export const SET_TECHDOC_TO_DRAFT_SUCCESS = 'SET_TECHDOC_TO_DRAFT_SUCCESS';
export const SET_TECHDOC_TO_DRAFT_ERROR = 'SET_TECHDOC_TO_DRAFT_ERROR';
export const UPDATE_BUSINESSINFO_NOTES_START = 'UPDATE_BUSINESSINFO_NOTES_START';
export const UPDATE_BUSINESSINFO_NOTES_SUCCESS = 'UPDATE_BUSINESSINFO_NOTES_SUCCESS';
export const UPDATE_BUSINESSINFO_NOTES_ERROR = 'UPDATE_BUSINESSINFO_NOTES_ERROR';
export const UPDATE_BUSINESSINFO_STATUS_START = 'UPDATE_BUSINESSINFO_STATUS_START';
export const UPDATE_BUSINESSINFO_STATUS_SUCCESS = 'UPDATE_BUSINESSINFO_STATUS_SUCCESS';
export const UPDATE_BUSINESSINFO_STATUS_ERROR = 'UPDATE_BUSINESSINFO_STATUS_ERROR';
export const UPDATE_LOCALE_START = 'UPDATE_LOCALE_START';
export const UPDATE_LOCALE_SUCCESS = 'UPDATE_LOCALE_SUCCESS';
export const UPDATE_LOCALE_ERROR = 'UPDATE_LOCALE_ERROR';
export const ADD_COMPANY = 'ADD_COMPANY';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';
export const ADD_COMPANY_ERROR = 'ADD_COMPANY_ERROR';
export const SEARCH_COMPANY_START = 'SEARCH_COMPANY_START';
export const SEARCH_COMPANY_SUCCESS = 'SEARCH_COMPANY_SUCCESS';
export const SEARCH_COMPANY_ERROR = 'SEARCH_COMPANY_ERROR';
export const RESET_COMPANY_LIST = 'RESET_COMPANY_LIST';
export const REMOVE_TECHDOC_START = 'REMOVE_TECHDOC_START';
export const REMOVE_TECHDOC_SUCCESS = 'REMOVE_TECHDOC_SUCCESS';
export const REMOVE_TECHDOC_ERROR = 'REMOVE_TECHDOC_ERROR';
export const REQUEST_ORDER_START = 'REQUEST_ORDER_START';
export const REQUEST_ORDER_SUCCESS = 'REQUEST_ORDER_SUCCESS';
export const REQUEST_ORDER_ERROR = 'REQUEST_ORDER_ERROR';

export const PLACE_ORDER_NATIONAL_START = 'PLACE_ORDER_NATIONAL_START';
export const PLACE_ORDER_NATIONAL_SUCCESS = 'PLACE_ORDER_NATIONAL_SUCCESS';
export const PLACE_ORDER_NATIONAL_ERROR = 'PLACE_ORDER_NATIONAL_ERROR';

export const PLACE_ORDER_FOREIGN_START = 'PLACE_ORDER_FOREIGN_START';
export const PLACE_ORDER_FOREIGN_SUCCESS = 'PLACE_ORDER_FOREIGN_SUCCESS';
export const PLACE_ORDER_FOREIGN_ERROR = 'PLACE_ORDER_FOREIGN_ERROR';

export const UPDATE_INVESTIGATION_CODES_START = 'UPDATE_INVESTIGATION_CODES_START';
export const UPDATE_INVESTIGATION_CODES_SUCCESS = 'UPDATE_INVESTIGATION_CODES_SUCCESS';
export const UPDATE_INVESTIGATION_CODES_ERROR = 'UPDATE_INVESTIGATION_CODES_ERROR';

export const QUESTIONNAIRE_ASSIGNUSER_START = 'QUESTIONNAIRE_ASSIGNUSER_START';
export const QUESTIONNAIRE_ASSIGNUSER_SUCCESS = 'QUESTIONNAIRE_ASSIGNUSER_SUCCESS';
export const QUESTIONNAIRE_ASSIGNUSER_ERROR = 'QUESTIONNAIRE_ASSIGNUSER_ERROR';

export const REQUEST_PASSWORD_RESET_REQUEST = 'REQUEST_PASSWORD_RESET_REQUEST';
export const REQUEST_PASSWORD_RESET_SUCCESS = 'REQUEST_PASSWORD_RESET_SUCCESS';
export const REQUEST_PASSWORD_RESET_FAILED = 'REQUEST_PASSWORD_RESET_FAILED';

export const RESET_PASSWORD_VALIDATE_TOKEN_REQUEST = 'RESET_PASSWORD_VALIDATE_TOKEN_REQUEST';
export const RESET_PASSWORD_VALIDATE_TOKEN_SUCCESS = 'RESET_PASSWORD_VALIDATE_TOKEN_SUCCESS';
export const RESET_PASSWORD_VALIDATE_TOKEN_FAILED = 'RESET_PASSWORD_VALIDATE_TOKEN_FAILED';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';

export const RESET_PASSWORD_RESET_PROCESS = 'RESET_PASSWORD_RESET_PROCESS';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED';

export const SUBMIT_FORM_START = 'SUBMIT_FORM_START';
export const SUBMIT_FORM_SUCCESS = 'SUBMIT_FORM_SUCCESS';
export const SUBMIT_FORM_ERROR = 'SUBMIT_FORM_ERROR';

export const ITALIAN_ORDER_PRICE_ENTRIES_REQUEST = 'ITALIAN_ORDER_PRICE_ENTRIES_REQUEST';
export const ITALIAN_ORDER_PRICE_ENTRIES_SUCCESS = 'ITALIAN_ORDER_PRICE_ENTRIES_SUCCESS';
export const ITALIAN_ORDER_PRICE_ENTRIES_FAILED = 'ITALIAN_ORDER_PRICE_ENTRIES_FAILED';

export const FOREIGN_ORDER_PRICE_ENTRIES_REQUEST = 'FOREIGN_ORDER_PRICE_ENTRIES_REQUEST';
export const FOREIGN_ORDER_PRICE_ENTRIES_SUCCESS = 'FOREIGN_ORDER_PRICE_ENTRIES_SUCCESS';
export const FOREIGN_ORDER_PRICE_ENTRIES_FAILED = 'FOREIGN_ORDER_PRICE_ENTRIES_FAILED';

export const UPLOAD_FILE_QUESTIONNAIRE_START = 'UPLOAD_FILE_QUESTIONNAIRE_START';
export const UPLOAD_FILE_QUESTIONNAIRE_SUCCESS = 'UPLOAD_FILE_QUESTIONNAIRE_SUCCESS';
export const UPLOAD_FILE_QUESTIONNAIRE_ERROR = 'UPLOAD_FILE_QUESTIONNAIRE_ERROR';

export const UPLOAD_FILE_CONTRACT_START = 'UPLOAD_FILE_CONTRACT_START';
export const UPLOAD_FILE_CONTRACT_SUCCESS = 'UPLOAD_FILE_CONTRACT_SUCCESS';
export const UPLOAD_FILE_CONTRACT_ERROR = 'UPLOAD_FILE_CONTRACT_ERROR';
export const UPLOAD_FILE_CONTRACT_NEW = 'UPLOAD_FILE_CONTRACT_NEW';

export const DELETE_FILE_QUESTIONNAIRE_START = 'DELETE_FILE_QUESTIONNAIRE_START';
export const DELETE_FILE_QUESTIONNAIRE_SUCCESS = 'DELETE_FILE_QUESTIONNAIRE_SUCCESS';
export const DELETE_FILE_QUESTIONNAIRE_ERROR = 'DELETE_FILE_QUESTIONNAIRE_ERROR';
export const SEND_QUESTIONNAIRE_START = 'SEND_QUESTIONNAIRE_START';
export const SEND_QUESTIONNAIRE_SUCCESS = 'SEND_QUESTIONNAIRE_SUCCESS';
export const SEND_QUESTIONNAIRE_ERROR = 'SEND_QUESTIONNAIRE_ERROR';

export const CREATE_CONTRACT_START = 'CREATE_CONTRACT_START';
export const CREATE_CONTRACT_SUCCESS = 'CREATE_CONTRACT_SUCCESS';
export const CREATE_CONTRACT_ERROR = 'CREATE_CONTRACT_ERROR';

export const REQUEST_PRICE_LIST_DEFAULT_START = 'REQUEST_PRICE_LIST_DEFAULT_START';
export const REQUEST_PRICE_LIST_DEFAULT_SUCCESS = 'REQUEST_PRICE_LIST_DEFAULT_SUCCESS';
export const REQUEST_PRICE_LIST_DEFAULT_ERROR = 'REQUEST_PRICE_LIST_DEFAULT_ERROR';

export const REJECT_QUESTIONNAIRE_START = 'REJECT_QUESTIONNAIRE_START';
export const REJECT_QUESTIONNAIRE_SUCCESS = 'REJECT_QUESTIONNAIRE_SUCCESS';
export const REJECT_QUESTIONNAIRE_ERROR = 'REJECT_QUESTIONNAIRE_ERROR';

export const APPROVE_QUESTIONNAIRE_START = 'APPROVE_QUESTIONNAIRE_START';
export const APPROVE_QUESTIONNAIRE_SUCCESS = 'APPROVE_QUESTIONNAIRE_SUCCESS';
export const APPROVE_QUESTIONNAIRE_ERROR = 'APPROVE_QUESTIONNAIRE_ERROR';

export const REQUEST_REVIEWING_QUESTIONNAIRES_START = 'REQUEST_REVIEWING_QUESTIONNAIRES_START';
export const REQUEST_REVIEWING_QUESTIONNAIRES_SUCCESS = 'REQUEST_REVIEWING_QUESTIONNAIRES_SUCCESS';
export const REQUEST_REVIEWING_QUESTIONNAIRES_ERROR = 'REQUEST_REVIEWING_QUESTIONNAIRES_ERROR';

export const CREATE_COMPANY_BUDGET_START = 'CREATE_COMPANY_BUDGET_START';
export const CREATE_COMPANY_BUDGET_SUCCESS = 'CREATE_COMPANY_BUDGET_SUCCESS';
export const CREATE_COMPANY_BUDGET_ERROR = 'CREATE_COMPANY_BUDGET_ERROR';

export const UPDATE_COMPANY_BUDGET_START = 'UPDATE_COMPANY_BUDGET_START';
export const UPDATE_COMPANY_BUDGET_SUCCESS = 'UPDATE_COMPANY_BUDGET_SUCCESS';
export const UPDATE_COMPANY_BUDGET_ERROR = 'UPDATE_COMPANY_BUDGET_ERROR';

export const COMPLETE_ORDER_START = 'COMPLETE_ORDER_START';
export const COMPLETE_ORDER_SUCCESS = 'COMPLETE_ORDER_SUCCESS';
export const COMPLETE_ORDER_ERROR = 'COMPLETE_ORDER_ERROR';

export const REOPEN_ORDER_START = 'REOPEN_ORDER_START';
export const REOPEN_ORDER_SUCCESS = 'REOPEN_ORDER_SUCCESS';
export const REOPEN_ORDER_ERROR = 'REOPEN_ORDER_ERROR';

export const REQUEST_ORDERED_COMPANIES_OVERVIEW_START = 'REQUEST_ORDERED_COMPANIES_OVERVIEW_START';
export const REQUEST_ORDERED_COMPANIES_OVERVIEW_SUCCESS = 'REQUEST_ORDERED_COMPANIES_OVERVIEW_SUCCESS';
export const REQUEST_ORDERED_COMPANIES_OVERVIEW_ERROR = 'REQUEST_ORDERED_COMPANIES_OVERVIEW_ERROR';

export const EDIT_COMPANY_START = 'EDIT_COMPANY_START';
export const EDIT_COMPANY_SUCCESS = 'EDIT_COMPANY_SUCCESS';
export const EDIT_COMPANY_ERROR = 'EDIT_COMPANY_ERROR';

export const RESEND_ACCOUNT_ACTIVATION_EMAIL_START = 'RESEND_ACCOUNT_ACTIVATION_EMAIL_START';
export const RESEND_ACCOUNT_ACTIVATION_EMAIL_SUCCESS = 'RESEND_ACCOUNT_ACTIVATION_EMAIL_SUCCESS';
export const RESEND_ACCOUNT_ACTIVATION_EMAIL_ERROR = 'RESEND_ACCOUNT_ACTIVATION_EMAIL_ERROR';

export const EDIT_USER_START = 'EDIT_USER_START';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_ERROR = 'EDIT_USER_ERROR';

export const REMOVE_USER_START = 'REMOVE_USER_START';
export const REMOVE_USER_SUCCESS = 'REMOVE_USER_SUCCESS';
export const REMOVE_USER_ERROR = 'REMOVE_USER_ERROR';
export const SET_QUESTIONNAIRE_TO_DRAFT_START = 'SET_QUESTIONNAIRE_TO_DRAFT_START';
export const SET_QUESTIONNAIRE_TO_DRAFT_SUCCESS = 'SET_QUESTIONNAIRE_TO_DRAFT_SUCCESS';
export const SET_QUESTIONNAIRE_TO_DRAFT_ERROR = 'SET_QUESTIONNAIRE_TO_DRAFT_ERROR';
export const SET_BUSINESSINFO_TO_DRAFT_START = 'SET_BUSINESSINFO_TO_DRAFT_START';
export const SET_BUSINESSINFO_TO_DRAFT_SUCCESS = 'SET_BUSINESSINFO_TO_DRAFT_SUCCESS';
export const SET_BUSINESSINFO_TO_DRAFT_ERROR = 'SET_BUSINESSINFO_TO_DRAFT_ERROR';

function actionsFactory() {
  const factory = {
    reqLogin,
    reqLogout,
    skipLogin,
    authGranted,
    authError,
    reqLoginReset,
    state,
    reqMe,
    myDataReceived,
    getMeErr,
    reqClientUserListStart,
    reqNonClientUserListStart,
    reqEditorUserListStart,
    reqUserListStart,
    reqUserListSuccess,
    reqUserListError,
    reqActivationStart,
    reqActivationSuccess,
    reqActivationError,
    reqReviewing,
    reqReviewingSuccess,
    reqReviewingError,
    sendActivationPasswords,
    sendActivationPasswordError,
    finishActivation,
    acceptUser,
    acceptUserSuccess,
    acceptUserError,
    refuseUser,
    refuseUserSuccess,
    refuseUserError,
    addUser,
    addUserSuccess,
    addUserError,
    reqCompanyList,
    reqCompanyListSuccess,
    reqCompanyListError,
    reqBusinessInfo,
    reqBusinessInfoSuccess,
    reqBusinessInfoError,
    reqBusinessInfoOrder,
    reqBusinessInfoOrderSuccess,
    reqBusinessInfoOrderError,
    reqCompanyStructure,
    reqCompanyStructureSuccess,
    reqCompanyStructureError,
    reqCompanyContractsStart,
    reqCompanyContractsSuccess,
    reqCompanyContractsError,
    reqCompanyBudgets,
    reqCompanyBudgetsSuccess,
    reqCompanyBudgetsError,
    reqEnumList,
    reqEnumSuccess,
    reqEnumError,
    reqTechDoc,
    reqTechDocSuccess,
    reqTechDocError,
    reqTechDocList,
    reqTechDocListSuccess,
    reqTechDocListError,
    reqQuestionnaireListStart,
    reqQuestionnaireListSuccess,
    reqQuestionnaireListError,
    reqQuestionnaireStart,
    reqQuestionnaireSuccess,
    reqQuestionnaireError,
    updateQuestionnaireStart,
    updateQuestionnaireSuccess,
    updateQuestionnaireError,
    updateTechDoc,
    updateTechDocError,
    updateTechDocSuccess,
    saveTechDocStart,
    saveTechDocSuccess,
    saveTechDocError,
    createTechDoc,
    createTechDocSuccess,
    createTechDocError,
    setTechDocToDraftStart,
    setTechDocToDraftSuccess,
    setTechDocToDraftError,
    updateBusinessInfoNotes,
    updateBusinessInfoNotesSuccess,
    updateBusinessInfoNotesError,
    setBusinessInfoCompleted,
    setBusinessInfoCompletedSuccess,
    setBusinessInfoCompletedError,
    updateLocale,
    updateLocaleSuccess,
    updateLocaleError,
    createCompany,
    createCompanySuccess,
    createCompanyError,
    searchCompany,
    searchCompanySuccess,
    searchCompanyError,
    resetCompanyList,
    removeTechDoc,
    removeTechDocSuccess,
    removeTechDocError,
    requestResetPasswordRequest,
    requestResetPasswordSuccess,
    requestResetPasswordFailed,
    validateResetPasswordTokenRequest,
    validateResetPasswordTokenSuccess,
    validateResetPasswordTokenFailed,
    resetPasswordRequest,
    resetPasswordSuccess,
    resetPasswordFailed,
    initialiseResetPasswordProcess,
    changePasswordRequest,
    changePasswordSuccess,
    changePasswordFailed,
    reqOrders,
    reqOrdersSuccess,
    reqOrdersError,
    placeOrderNationalStart,
    placeOrderNationalSuccess,
    placeOrderNationalError,
    placeOrderForeignStart,
    placeOrderForeignSuccess,
    placeOrderForeignError,
    updateInvestigationCodesStart,
    updateInvestigationCodesSuccess,
    updateInvestigationCodesError,
    assignContactUser,
    assignContactUserSuccess,
    assignContactUserError,
    submitFormStart,
    submitFormSuccess,
    submitFormError,
    reqCompanyDetails,
    companyDetailsSuccess,
    companyDetailsError,
    italianOrderPriceEntriesRequest,
    italianOrderPriceEntriesSuccess,
    italianOrderPriceEntriesFailed,
    foreignOrderPriceEntriesRequest,
    foreignOrderPriceEntriesSuccess,
    foreignOrderPriceEntriesFailed,
    uploadFileQuestionnaireStart,
    uploadFileQuestionnaireSuccess,
    uploadFileQuestionnaireError,
    deleteFileQuestionnaireStart,
    deleteFileQuestionnaireSuccess,
    deleteFileQuestionnaireError,
    sendQuestionnaireStart,
    sendQuestionnaireSuccess,
    sendQuestionnaireError,
    updateContractStart,
    updateContractSuccess,
    updateContractError,
    createContractStart,
    createContractSuccess,
    createContractError,
    reqPriceListDefaultStart,
    reqPriceListDefaultSuccess,
    reqPriceListDefaultError,
    rejectQuestionnaireStart,
    rejectQuestionnaireSuccess,
    rejectQuestionnaireError,
    approveQuestionnaireStart,
    approveQuestionnaireSuccess,
    approveQuestionnaireError,
    reqReviewingQuestionnairesStart,
    reqReviewingQuestionnairesSuccess,
    reqReviewingQuestionnairesError,
    createBudgetStart,
    createBudgetSuccess,
    createBudgetError,
    updateBudgetStart,
    updateBudgetSuccess,
    updateBudgetError,
    completeOrderStart,
    completeOrderSuccess,
    completeOrderError,
    reopenOrderStart,
    reopenOrderSuccess,
    reopenOrderError,
    requestOrderedCompaniesOverviewStart,
    requestOrderedCompaniesOverviewSuccess,
    requestOrderedCompaniesOverviewError,
    editCompanyStart,
    editCompanySuccess,
    editCompanyError,
    resendAccountActivationEmailStart,
    resendAccountActivationEmailSuccess,
    resendAccountActivationEmailError,
    editUserStart,
    editUserSuccess,
    editUserError,
    removeUserStart,
    removeUserSuccess,
    removeUserError,
    setQuestionnaireToDraftStart,
    setQuestionnaireToDraftSuccess,
    setQuestionnaireToDraftError,
    setBusinessInfoToDraftStart,
    setBusinessInfoToDraftSuccess,
    setBusinessInfoToDraftError,
  };

  return factory;

  function reqLogin(username, password) {
    return {
      type: REQUEST_LOGIN,
      username,
      password,
    };
  }

  function reqLogout() {
    return {
      type: REQUEST_LOGOUT,
    };
  }

  function skipLogin(user) {
    return {
      type: SKIP_LOGIN,
      user,
    };
  }

  function authGranted(jwt, user) {
    return {
      type: AUTH_GRANTED,
      jwt,
      user,
    };
  }

  function authError(err) {
    return {
      type: AUTH_ERROR,
      err,
    };
  }

  function reqLoginReset() {
    return {
      type: REQUEST_LOGIN_RESET,
    };
  }

  function state(to, params, options) {
    if (!to) {
      return stateReload();
    }
    return stateGo(to, params, options);
  }

  function reqMe() {
    return {
      type: REQUEST_ME,
    };
  }

  function myDataReceived(myData) {
    return {
      type: REQUEST_ME_SUCCESS,
      myData,
    };
  }

  function getMeErr(err) {
    return {
      type: REQUEST_ME_ERROR,
      err,
    };
  }

  function reqClientUserListStart(params) {
    return {
      type: REQUEST_CLIENT_USERLIST_START,
      params,
    };
  }

  function reqNonClientUserListStart(params) {
    return {
      type: REQUEST_NON_CLIENT_USERLIST_START,
      params,
    };
  }

  function reqEditorUserListStart(params) {
    return {
      type: REQUEST_EDITOR_USERLIST_START,
      params,
    };
  }

  function reqUserListStart(params) {
    return {
      type: REQUEST_USERLIST_START,
      params,
    };
  }
  function reqUserListSuccess(data) {
    return {
      type: REQUEST_USERLIST_SUCCESS,
      data,
    };
  }
  function reqUserListError(err) {
    return {
      type: REQUEST_USERLIST_ERROR,
      err,
    };
  }
  function sendActivationPasswords(token, password, passwordConfirmation) {
    return {
      type: ACTIVATION_PASSWORD_START,
      password,
      password_confirmation: passwordConfirmation,
      token,
    };
  }
  function sendActivationPasswordError(error) {
    return {
      type: ACTIVATION_PASSWORD_ERROR,
      errorPassword: error,
    };
  }
  function reqActivationStart(token) {
    return {
      type: ACTIVATION_START,
      token,
    };
  }
  function reqActivationSuccess(data) {
    return {
      type: ACTIVATION_SUCCESS,
      data,
    };
  }
  function reqActivationError(err) {
    return {
      type: ACTIVATION_ERROR,
      err,
    };
  }
  function finishActivation() {
    return {
      type: ACTIVATION_FINISH,
    };
  }

  function refuseUser(user, reason) {
    return {
      type: REFUSE_USER,
      user,
      reason,
    };
  }

  function refuseUserSuccess() {
    return {
      type: REFUSE_USER_SUCCESS,
    };
  }

  function refuseUserError(err) {
    return {
      type: REFUSE_USER_ERROR,
      err,
    };
  }

  function acceptUser(user) {
    return {
      type: ACCEPT_USER,
      user,
    };
  }

  function acceptUserSuccess() {
    return {
      type: ACCEPT_USER_SUCCESS,
    };
  }

  function acceptUserError(err) {
    return {
      type: ACCEPT_USER_ERROR,
      err,
    };
  }

  function addUser(user) {
    return {
      type: ADD_USER,
      user,
    };
  }
  function addUserSuccess(user) {
    return {
      type: ADD_USER_SUCCESS,
      user,
    };
  }
  function addUserError(user) {
    return {
      type: ADD_USER_ERROR,
      user,
    };
  }
  function reqReviewing(client) {
    return {
      type: REVIEWING_ASK,
      client,
    };
  }
  function reqReviewingSuccess(data) {
    return {
      type: REVIEWING_ASK_SUCCESS,
      data,
    };
  }
  function reqReviewingError(err) {
    return {
      type: REVIEWING_ASK_ERROR,
      err,
    };
  }
  function reqCompanyList(paramList) {
    return {
      type: REQUEST_COMPANYLIST_START,
      paramList,
    };
  }
  function reqCompanyListSuccess(data) {
    return {
      type: REQUEST_COMPANYLIST_SUCCESS,
      data,
    };
  }
  function reqCompanyListError(err) {
    return {
      type: REQUEST_COMPANYLIST_ERROR,
      err,
    };
  }
  function reqBusinessInfo(companyId, paramList) {
    return {
      type: REQUEST_BUSINESSINFO_START,
      companyId,
      paramList,
    };
  }
  function reqBusinessInfoSuccess(data) {
    return {
      type: REQUEST_BUSINESSINFO_SUCCESS,
      data,
    };
  }
  function reqBusinessInfoError(err) {
    return {
      type: REQUEST_BUSINESSINFO_ERROR,
      err,
    };
  }
  function reqBusinessInfoOrder(businessInfoId) {
    return {
      type: REQUEST_BUSINESSINFO_ORDER_START,
      businessInfoId,
    };
  }
  function reqBusinessInfoOrderSuccess(data) {
    return {
      type: REQUEST_BUSINESSINFO_ORDER_SUCCESS,
      data,
    };
  }
  function reqBusinessInfoOrderError(err) {
    return {
      type: REQUEST_BUSINESSINFO_ORDER_ERROR,
      err,
    };
  }

  function reqCompanyStructure(companyId) {
    return {
      type: REQUEST_COMPANY_STRUCTURE_START,
      companyId,
    };
  }

  function reqCompanyStructureSuccess(data, companyId) {
    return {
      type: REQUEST_COMPANY_STRUCTURE_SUCCESS,
      data,
      companyId,
    };
  }

  function reqCompanyStructureError(err) {
    return {
      type: REQUEST_COMPANY_STRUCTURE_ERROR,
      err,
    };
  }

  function reqCompanyContractsStart(companyId) {
    return {
      type: REQUEST_COMPANY_CONTRACTS_START,
      companyId,
    };
  }

  function reqCompanyContractsSuccess(data, companyId) {
    return {
      type: REQUEST_COMPANY_CONTRACTS_SUCCESS,
      data,
      companyId,
    };
  }

  function reqCompanyContractsError(err) {
    return {
      type: REQUEST_COMPANY_CONTRACTS_ERROR,
      err,
    };
  }

  function reqCompanyBudgets(companyId) {
    return {
      type: REQUEST_COMPANY_BUDGETS_START,
      companyId,
    };
  }

  function reqCompanyBudgetsSuccess(data, companyId) {
    return {
      type: REQUEST_COMPANY_BUDGETS_SUCCESS,
      data,
      companyId,
    };
  }

  function reqCompanyBudgetsError(err) {
    return {
      type: REQUEST_COMPANY_BUDGETS_ERROR,
      err,
    };
  }


  function reqEnumList(path) {
    return {
      type: REQUEST_ENUM_START,
      path,
    };
  }

  function reqEnumSuccess(data, path) {
    return {
      type: REQUEST_ENUM_SUCCESS,
      data,
      path,
    };
  }

  function reqEnumError(err) {
    return {
      type: REQUEST_ENUM_ERROR,
      err,
    };
  }

  function reqTechDocList(companyId) {
    return {
      type: REQUEST_TECHDOCLIST_START,
      companyId,
    };
  }

  function reqTechDocListSuccess(data) {
    return {
      type: REQUEST_TECHDOCLIST_SUCCESS,
      data,
    };
  }

  function reqTechDocListError(err) {
    return {
      type: REQUEST_TECHDOCLIST_ERROR,
      err,
    };
  }

  function reqTechDoc(companyId, techDocId) {
    return {
      type: REQUEST_TECHDOC_START,
      techDocId,
      companyId,
    };
  }

  function reqTechDocSuccess(data) {
    return {
      type: REQUEST_TECHDOC_SUCCESS,
      data,
    };
  }

  function reqTechDocError(err) {
    return {
      type: REQUEST_TECHDOC_ERROR,
      err,
    };
  }

  function reqQuestionnaireListStart(companyId) {
    return {
      type: REQUEST_QUESTIONNAIRELIST_START,
      companyId,
    };
  }

  function reqQuestionnaireListSuccess(data) {
    return {
      type: REQUEST_QUESTIONNAIRELIST_SUCCESS,
      data,
    };
  }

  function reqQuestionnaireListError(err) {
    return {
      type: REQUEST_QUESTIONNAIRELIST_ERROR,
      err,
    };
  }

  function reqQuestionnaireStart(companyId, questionnaireId) {
    return {
      type: REQUEST_QUESTIONNAIRE_START,
      companyId,
      questionnaireId,
    };
  }

  function reqQuestionnaireSuccess(data) {
    return {
      type: REQUEST_QUESTIONNAIRE_SUCCESS,
      data,
    };
  }

  function reqQuestionnaireError(err) {
    return {
      type: REQUEST_QUESTIONNAIRE_ERROR,
      err,
    };
  }

  function updateQuestionnaireStart(questionnaireId, content, score, notes) {
    return {
      type: UPDATE_QUESTIONNAIRE_START,
      questionnaireId,
      content,
      score,
      notes,
    };
  }

  function updateQuestionnaireSuccess(data) {
    return {
      type: UPDATE_QUESTIONNAIRE_SUCCESS,
      data,
    };
  }

  function updateQuestionnaireError(err) {
    return {
      type: UPDATE_QUESTIONNAIRE_ERROR,
      err,
    };
  }

  function updateTechDoc(companyId, techDocId, content) {
    return {
      type: UPDATE_TECHDOC,
      content,
      companyId,
      techDocId,
    };
  }

  function updateTechDocError(err) {
    return {
      type: UPDATE_TECHDOC_ERROR,
      err,
    };
  }

  function updateTechDocSuccess(data) {
    return {
      type: UPDATE_TECHDOC_SUCCESS,
      data,
    };
  }

  function saveTechDocStart(companyId, techDocId, content) {
    return {
      type: SAVE_TECHDOC_START,
      content,
      companyId,
      techDocId,
    };
  }

  function saveTechDocSuccess(data) {
    return {
      type: SAVE_TECHDOC_SUCCESS,
      data,
    };
  }

  function saveTechDocError(err) {
    return {
      type: SAVE_TECHDOC_ERROR,
      err,
    };
  }

  function createTechDoc(companyId) {
    return {
      type: CREATE_TECHDOC,
      companyId,
    };
  }

  function createTechDocSuccess(data) {
    return {
      type: CREATE_TECHDOC_SUCCESS,
      data,
    };
  }

  function createTechDocError(err) {
    return {
      type: CREATE_TECHDOC_ERROR,
      err,
    };
  }

  function setTechDocToDraftStart(companyId, techDocId) {
    return {
      type: SET_TECHDOC_TO_DRAFT_START,
      companyId,
      techDocId,
    };
  }

  function setTechDocToDraftSuccess(data, companyId, techDocId) {
    return {
      type: SET_TECHDOC_TO_DRAFT_SUCCESS,
      data,
      companyId,
      techDocId,
    };
  }

  function setTechDocToDraftError(err) {
    return {
      type: SET_TECHDOC_TO_DRAFT_ERROR,
      err,
    };
  }

  function updateBusinessInfoNotes(id, notes, score, trustStatement, companyId, companyContacts) {
    return {
      type: UPDATE_BUSINESSINFO_NOTES_START,
      id,
      notes,
      score,
      trustStatement,
      companyId,
      companyContacts,
    };
  }

  function updateBusinessInfoNotesSuccess(data) {
    return {
      type: UPDATE_BUSINESSINFO_NOTES_SUCCESS,
      data,
    };
  }

  function updateBusinessInfoNotesError(err) {
    return {
      type: UPDATE_BUSINESSINFO_NOTES_ERROR,
      err,
    };
  }

  function setBusinessInfoCompleted(id, notes, score, trustStatement, companyId, companyContacts) {
    return {
      type: UPDATE_BUSINESSINFO_STATUS_START,
      id,
      notes,
      score,
      trustStatement,
      companyId,
      companyContacts,
    };
  }

  function setBusinessInfoCompletedSuccess(data) {
    return {
      type: UPDATE_BUSINESSINFO_STATUS_SUCCESS,
      data,
    };
  }

  function setBusinessInfoCompletedError(err) {
    return {
      type: UPDATE_BUSINESSINFO_STATUS_ERROR,
      err,
    };
  }

  function updateLocale(locale) {
    return {
      type: UPDATE_LOCALE_START,
      locale,
    };
  }

  function updateLocaleSuccess(data) {
    return {
      type: UPDATE_LOCALE_SUCCESS,
      data,
    };
  }

  function updateLocaleError(err) {
    return {
      type: UPDATE_LOCALE_ERROR,
      err,
    };
  }

  function createCompany(data) {
    return {
      type: ADD_COMPANY,
      data,
    };
  }

  function createCompanySuccess(data) {
    return {
      type: ADD_COMPANY_SUCCESS,
      data,
    };
  }

  function createCompanyError(err) {
    return {
      type: ADD_COMPANY_ERROR,
      err,
    };
  }

  function searchCompany(data) {
    return {
      type: SEARCH_COMPANY_START,
      data,
    };
  }

  function searchCompanySuccess(data) {
    return {
      type: SEARCH_COMPANY_SUCCESS,
      data,
    };
  }

  function searchCompanyError(err) {
    return {
      type: SEARCH_COMPANY_ERROR,
      err,
    };
  }

  function resetCompanyList() {
    return {
      type: RESET_COMPANY_LIST,
    };
  }

  function uploadFileQuestionnaireStart(file, dataset, id) {
    return {
      type: UPLOAD_FILE_QUESTIONNAIRE_START,
      file,
      dataset,
      id,
    };
  }

  function uploadFileQuestionnaireSuccess(file, dataset, id) {
    return {
      type: UPLOAD_FILE_QUESTIONNAIRE_SUCCESS,
      file,
      dataset,
      id,
    };
  }

  function uploadFileQuestionnaireError(err) {
    return {
      type: UPLOAD_FILE_QUESTIONNAIRE_ERROR,
      err,
    };
  }

  function removeTechDoc(companyId, techDocId) {
    return {
      type: REMOVE_TECHDOC_START,
      companyId,
      techDocId,
    };
  }

  function removeTechDocSuccess(companyId, techDocId, data) {
    return {
      type: REMOVE_TECHDOC_SUCCESS,
      data,
      companyId,
      techDocId,
    };
  }

  function removeTechDocError(err) {
    return {
      type: REMOVE_TECHDOC_ERROR,
      err,
    };
  }

  function requestResetPasswordRequest(email) {
    return {
      type: REQUEST_PASSWORD_RESET_REQUEST,
      email,
    };
  }

  function requestResetPasswordSuccess() {
    return {
      type: REQUEST_PASSWORD_RESET_SUCCESS,
    };
  }

  function requestResetPasswordFailed(error) {
    return {
      type: REQUEST_PASSWORD_RESET_FAILED,
      error,
    };
  }

  function validateResetPasswordTokenRequest(token, email) {
    return {
      type: RESET_PASSWORD_VALIDATE_TOKEN_REQUEST,
      token,
      email,
    };
  }

  function validateResetPasswordTokenSuccess(user) {
    return {
      type: RESET_PASSWORD_VALIDATE_TOKEN_SUCCESS,
      user,
    };
  }

  function validateResetPasswordTokenFailed(error) {
    return {
      type: RESET_PASSWORD_VALIDATE_TOKEN_FAILED,
      error,
    };
  }

  function resetPasswordRequest(token, email, password, passwordConfirmation) {
    return {
      type: RESET_PASSWORD_REQUEST,
      token,
      email,
      password,
      passwordConfirmation,
    };
  }

  function resetPasswordSuccess() {
    return {
      type: RESET_PASSWORD_SUCCESS,
    };
  }

  function resetPasswordFailed(error) {
    return {
      type: RESET_PASSWORD_FAILED,
      error,
    };
  }

  function initialiseResetPasswordProcess() {
    return {
      type: RESET_PASSWORD_RESET_PROCESS,
    };
  }

  function changePasswordRequest(currentPassword, password, passwordConfirmation) {
    return {
      type: CHANGE_PASSWORD_REQUEST,
      currentPassword,
      password,
      passwordConfirmation,
    };
  }

  function changePasswordSuccess() {
    return {
      type: CHANGE_PASSWORD_SUCCESS,
    };
  }

  function changePasswordFailed(error) {
    return {
      type: CHANGE_PASSWORD_FAILED,
      error,
    };
  }

  function reqOrders(listType, params) {
    return {
      type: REQUEST_ORDER_START,
      listType,
      params,
    };
  }

  function reqOrdersSuccess(data, listType) {
    return {
      type: REQUEST_ORDER_SUCCESS,
      data,
      listType,
    };
  }

  function reqOrdersError(err, listType) {
    return {
      type: REQUEST_ORDER_ERROR,
      err,
      listType,
    };
  }

  function deleteFileQuestionnaireStart(data, id) {
    return {
      type: DELETE_FILE_QUESTIONNAIRE_START,
      data,
      id,
    };
  }

  function deleteFileQuestionnaireSuccess(data, id) {
    return {
      type: DELETE_FILE_QUESTIONNAIRE_SUCCESS,
      data,
      id,
    };
  }

  function deleteFileQuestionnaireError(err) {
    return {
      type: DELETE_FILE_QUESTIONNAIRE_ERROR,
      err,
    };
  }

  function placeOrderNationalStart(order) {
    return {
      type: PLACE_ORDER_NATIONAL_START,
      order,
    };
  }

  function placeOrderNationalSuccess(data) {
    return {
      type: PLACE_ORDER_NATIONAL_SUCCESS,
      data,
    };
  }

  function placeOrderNationalError(err) {
    return {
      type: PLACE_ORDER_NATIONAL_ERROR,
      err,
    };
  }

  function placeOrderForeignStart(order) {
    return {
      type: PLACE_ORDER_FOREIGN_START,
      order,
    };
  }

  function placeOrderForeignSuccess(data) {
    return {
      type: PLACE_ORDER_FOREIGN_SUCCESS,
      data,
    };
  }

  function placeOrderForeignError(err) {
    return {
      type: PLACE_ORDER_FOREIGN_ERROR,
      err,
    };
  }

  function updateInvestigationCodesStart(orderId, investigation) {
    return {
      type: UPDATE_INVESTIGATION_CODES_START,
      orderId,
      investigation,
    };
  }

  function updateInvestigationCodesSuccess(data) {
    return {
      type: UPDATE_INVESTIGATION_CODES_SUCCESS,
      data,
    };
  }

  function updateInvestigationCodesError(err) {
    return {
      type: UPDATE_INVESTIGATION_CODES_ERROR,
      err,
    };
  }

  function assignContactUser(questionnaireId, userId) {
    return {
      type: QUESTIONNAIRE_ASSIGNUSER_START,
      userId,
      questionnaireId,
    };
  }

  function assignContactUserError(err) {
    return {
      type: QUESTIONNAIRE_ASSIGNUSER_ERROR,
      err,
    };
  }

  function assignContactUserSuccess(data) {
    return {
      type: QUESTIONNAIRE_ASSIGNUSER_SUCCESS,
      data,
    };
  }

  function submitFormStart(user) {
    return {
      type: SUBMIT_FORM_START,
      user,
    };
  }

  function submitFormError(err) {
    return {
      type: SUBMIT_FORM_ERROR,
      err,
    };
  }

  function submitFormSuccess(result) {
    return {
      type: SUBMIT_FORM_SUCCESS,
      result,
    };
  }

  function reqCompanyDetails(id) {
    return {
      type: REQUEST_COMPANY_START,
      id,
    };
  }

  function companyDetailsSuccess(data) {
    return {
      type: REQUEST_COMPANY_SUCCESS,
      data,
    };
  }

  function companyDetailsError(error) {
    return {
      type: REQUEST_COMPANY_ERROR,
      error,
    };
  }

  function italianOrderPriceEntriesRequest(searchEntry) {
    return {
      type: ITALIAN_ORDER_PRICE_ENTRIES_REQUEST,
      searchEntry,
    };
  }

  function italianOrderPriceEntriesSuccess(entries, availableCredits) {
    return {
      type: ITALIAN_ORDER_PRICE_ENTRIES_SUCCESS,
      entries,
      availableCredits,
    };
  }

  function italianOrderPriceEntriesFailed(error) {
    return {
      type: ITALIAN_ORDER_PRICE_ENTRIES_FAILED,
      error,
    };
  }

  function foreignOrderPriceEntriesRequest(searchEntry, countryCode) {
    return {
      type: FOREIGN_ORDER_PRICE_ENTRIES_REQUEST,
      searchEntry,
      countryCode,
    };
  }

  function foreignOrderPriceEntriesSuccess(entries, availableCredits) {
    return {
      type: FOREIGN_ORDER_PRICE_ENTRIES_SUCCESS,
      entries,
      availableCredits,
    };
  }

  function foreignOrderPriceEntriesFailed(error) {
    return {
      type: FOREIGN_ORDER_PRICE_ENTRIES_FAILED,
      error,
    };
  }

  function sendQuestionnaireStart(questionnaireId, content) {
    return {
      type: SEND_QUESTIONNAIRE_START,
      questionnaireId,
      content,
    };
  }

  function sendQuestionnaireSuccess(data) {
    return {
      type: SEND_QUESTIONNAIRE_SUCCESS,
      data,
    };
  }

  function sendQuestionnaireError(err) {
    return {
      type: SEND_QUESTIONNAIRE_ERROR,
      err,
    };
  }

  function updateContractStart(companyId, contractId, contract) {
    return {
      type: UPDATE_CONTRACT_START,
      companyId,
      contractId,
      contract,
    };
  }

  function updateContractSuccess(data, companyId) {
    return {
      type: UPDATE_CONTRACT_SUCCESS,
      data,
      companyId,
    };
  }

  function updateContractError(err) {
    return {
      type: UPDATE_CONTRACT_ERROR,
      err,
    };
  }

  function createContractStart(companyId, contract) {
    return {
      type: CREATE_CONTRACT_START,
      companyId,
      contract,
    };
  }

  function createContractSuccess(data, companyId) {
    return {
      type: CREATE_CONTRACT_SUCCESS,
      data,
      companyId,
    };
  }

  function createContractError(err) {
    return {
      type: CREATE_CONTRACT_ERROR,
      err,
    };
  }

  function reqPriceListDefaultStart() {
    return {
      type: REQUEST_PRICE_LIST_DEFAULT_START,
    };
  }

  function reqPriceListDefaultSuccess(data) {
    return {
      type: REQUEST_PRICE_LIST_DEFAULT_SUCCESS,
      data,
    };
  }

  function reqPriceListDefaultError() {
    return {
      type: REQUEST_PRICE_LIST_DEFAULT_ERROR,
    };
  }

  function rejectQuestionnaireStart(questionnaireId) {
    return {
      type: REJECT_QUESTIONNAIRE_START,
      questionnaireId,
    };
  }

  function rejectQuestionnaireSuccess(data) {
    return {
      type: REJECT_QUESTIONNAIRE_SUCCESS,
      data,
    };
  }

  function rejectQuestionnaireError(err) {
    return {
      type: REJECT_QUESTIONNAIRE_ERROR,
      err,
    };
  }

  function approveQuestionnaireStart(questionnaireId, content, manualScores) {
    return {
      type: APPROVE_QUESTIONNAIRE_START,
      questionnaireId,
      content,
      manualScores,
    };
  }

  function approveQuestionnaireSuccess(data) {
    return {
      type: APPROVE_QUESTIONNAIRE_SUCCESS,
      data,
    };
  }

  function approveQuestionnaireError(err) {
    return {
      type: APPROVE_QUESTIONNAIRE_ERROR,
      err,
    };
  }

  function createBudgetStart(companyId, ownerId, parentBudgetId) {
    return {
      type: CREATE_COMPANY_BUDGET_START,
      companyId,
      ownerId,
      parentBudgetId,
    };
  }

  function createBudgetSuccess(companyId, data) {
    return {
      type: CREATE_COMPANY_BUDGET_SUCCESS,
      data,
      companyId,
    };
  }

  function createBudgetError(err) {
    return {
      type: CREATE_COMPANY_BUDGET_ERROR,
      err,
    };
  }

  function updateBudgetStart(companyId, budgetId, credits) {
    return {
      type: UPDATE_COMPANY_BUDGET_START,
      companyId,
      budgetId,
      credits,
    };
  }

  function updateBudgetSuccess(data) {
    return {
      type: UPDATE_COMPANY_BUDGET_SUCCESS,
      data,
    };
  }

  function updateBudgetError(err) {
    return {
      type: UPDATE_COMPANY_BUDGET_ERROR,
      err,
    };
  }
}

function reqReviewingQuestionnairesStart(params) {
  return {
    type: REQUEST_REVIEWING_QUESTIONNAIRES_START,
    params,
  };
}

function reqReviewingQuestionnairesSuccess(data) {
  return {
    type: REQUEST_REVIEWING_QUESTIONNAIRES_SUCCESS,
    data,
  };
}

function reqReviewingQuestionnairesError(err) {
  return {
    type: REQUEST_REVIEWING_QUESTIONNAIRES_ERROR,
    err,
  };
}

function completeOrderStart(orderId, message = null) {
  return {
    type: COMPLETE_ORDER_START,
    orderId,
    message,
  };
}

function completeOrderSuccess(data) {
  return {
    type: COMPLETE_ORDER_SUCCESS,
    data,
  };
}

function completeOrderError(err) {
  return {
    type: COMPLETE_ORDER_ERROR,
    err,
  };
}

function reopenOrderStart(orderId, message = null) {
  return {
    type: REOPEN_ORDER_START,
    orderId,
    message,
  };
}

function reopenOrderSuccess(data) {
  return {
    type: REOPEN_ORDER_SUCCESS,
    data,
  };
}

function reopenOrderError(err) {
  return {
    type: REOPEN_ORDER_ERROR,
    err,
  };
}

function requestOrderedCompaniesOverviewStart(params) {
  return {
    type: REQUEST_ORDERED_COMPANIES_OVERVIEW_START,
    params,
  };
}

function requestOrderedCompaniesOverviewSuccess(data) {
  return {
    type: REQUEST_ORDERED_COMPANIES_OVERVIEW_SUCCESS,
    data,
  };
}

function requestOrderedCompaniesOverviewError(err) {
  return {
    type: REQUEST_ORDERED_COMPANIES_OVERVIEW_ERROR,
    err,
  };
}

function editCompanyStart(id, company) {
  return {
    type: EDIT_COMPANY_START,
    id,
    company,
  };
}

function editCompanySuccess(data) {
  return {
    type: EDIT_COMPANY_SUCCESS,
    data,
  };
}

function editCompanyError(err) {
  return {
    type: EDIT_COMPANY_ERROR,
    err,
  };
}

function resendAccountActivationEmailStart(id) {
  return {
    type: RESEND_ACCOUNT_ACTIVATION_EMAIL_START,
    id,
  };
}

function resendAccountActivationEmailSuccess(data) {
  return {
    type: RESEND_ACCOUNT_ACTIVATION_EMAIL_SUCCESS,
    data,
  };
}

function resendAccountActivationEmailError(err) {
  return {
    type: RESEND_ACCOUNT_ACTIVATION_EMAIL_ERROR,
    err,
  };
}

function editUserStart(user) {
  return {
    type: EDIT_USER_START,
    user,
  };
}

function editUserSuccess(data) {
  return {
    type: EDIT_USER_SUCCESS,
    data,
  };
}

function editUserError(err) {
  return {
    type: EDIT_USER_ERROR,
    err,
  };
}

function removeUserStart(user) {
  return {
    type: REMOVE_USER_START,
    user,
  };
}

function removeUserSuccess(data) {
  return {
    type: REMOVE_USER_SUCCESS,
    data,
  };
}

function removeUserError(err) {
  return {
    type: REMOVE_USER_ERROR,
    err,
  };
}

function setQuestionnaireToDraftStart(questionnaireId, message) {
  return {
    type: SET_QUESTIONNAIRE_TO_DRAFT_START,
    questionnaireId,
    message,
  };
}

function setQuestionnaireToDraftSuccess(data, questionnaireId) {
  return {
    type: SET_QUESTIONNAIRE_TO_DRAFT_SUCCESS,
    data,
    questionnaireId,
  };
}

function setQuestionnaireToDraftError(err) {
  return {
    type: SET_QUESTIONNAIRE_TO_DRAFT_ERROR,
    err,
  };
}

function setBusinessInfoToDraftStart(businessInfoId, message) {
  return {
    type: SET_BUSINESSINFO_TO_DRAFT_START,
    businessInfoId,
    message,
  };
}

function setBusinessInfoToDraftSuccess(data, businessInfoId) {
  return {
    type: SET_BUSINESSINFO_TO_DRAFT_SUCCESS,
    data,
    businessInfoId,
  };
}

function setBusinessInfoToDraftError(err) {
  return {
    type: SET_BUSINESSINFO_TO_DRAFT_ERROR,
    err,
  };
}
